<div *ngIf="heeftWinst()" class="row">
    <form [formGroup]="loonInWinstFg">
            <snelstart-ui-number-form-control
                    formControlName="loonAlsOnderdeelVanWinst"
                    id="loonAlsOnderdeelVanWinst"
                    label="Bedrag brutoloon"
                    class="col-auto custom-input-200"
                    [decimals]="0"
                    align="right"
                    prefix="€"
                    (change)="saveForm()"
            >
            </snelstart-ui-number-form-control>
        <div *ngIf="this.isDefAangifte">
                <snelstart-ui-number-form-control
                        formControlName="loonheffingOverLoonAlsOnderdeelVanWinst"
                        id="loonheffingOverLoonAlsOnderdeelVanWinst"
                        label="Ingehouden loonheffing"
                        class="col-auto custom-input-200"
                        [decimals]="0"
                        align="right"
                        prefix="€"
                        (change)="saveForm()"
                >
                </snelstart-ui-number-form-control>
        </div>
    </form>
</div>


<div *ngIf="!heeftWinst()">
    Er is geen sprake van winst uit onderneming in deze aangifte.
</div>
